import { PasswordRecoveryCard } from "../components/password-recovery-card.tsx";

function PasswordRecovery() {
  return <PasswordRecoveryCard />;
}

export default PasswordRecovery;
